// extracted by mini-css-extract-plugin
export default {"popover":"PopoverSharedStyle_popover__4NhV9","active":"PopoverSharedStyle_active__V23wG","backdrop":"PopoverSharedStyle_backdrop__5qrgn"};